import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

interface Category {
  id: string;
  name: string;
  description: string;
}

interface CategoryOption {
  value: string;
  label: string;
}

export const useIngredientCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/ingredients/meta/categories`);
      const result = await response.json();

      if (result.success) {
        setCategories(result.data);
      } else {
        setError(result.error || 'Error al cargar categorías');
      }
    } catch (err) {
      console.error('Error fetching categories:', err);
      setError('Error de conexión al cargar categorías');
    } finally {
      setLoading(false);
    }
  };

  const getCategoryOptions = (): CategoryOption[] => {
    return categories.map(category => ({
      value: category.name, // Use name as value to match IngredientCategory type
      label: category.name
    }));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return {
    categories,
    categoryOptions: getCategoryOptions(),
    loading,
    error,
    refetch: fetchCategories
  };
};